import { render, staticRenderFns } from "./PavillionAngleCalculator.vue?vue&type=template&id=63016c56&"
import script from "./PavillionAngleCalculator.vue?vue&type=script&lang=js&"
export * from "./PavillionAngleCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports